module.exports = __webpack_public_path__ + "img/Small house logo Icon - charcoal.b7c91039.svg";